/**
 * Answer timeout (agion/Agion#2078): a run that failed because nobody answered
 * its question in time. The chat names it as a timeout instead of the generic
 * failure line, which sends the person to support for nothing.
 *
 * The failure event and the stored mission_ended event carry no reason code
 * for it, only the runner's error text, so this is the one place that reads
 * those texts. They are every "Timed out waiting" text mission-runner ends a
 * run with (platform/agion-core/mission-runner/pkg/mode/adaptive/loop.go). A
 * question left unanswered later in a run ends it as user_ended, not failed.
 * Any other failure text keeps the generic line.
 */

/** The runner's error texts for a run that ended waiting for an answer. */
const ANSWER_TIMEOUT_ERRORS: ReadonlySet<string> = new Set([
  'Timed out waiting for first message',
  'Timed out waiting for first message after greeting',
])

/** The failure line for an answer timeout. */
export const ANSWER_TIMEOUT = {
  key: 'chat:customer.missionAnswerTimeout',
  fallback: 'The run ended because no answer came in time. Send a message to start a new run.',
} as const

/** Whether a run's failure error is the runner's answer timeout. */
export function isAnswerTimeout(error: unknown): boolean {
  return typeof error === 'string' && ANSWER_TIMEOUT_ERRORS.has(error.trim())
}
